export function getClockInButtonText(isBadgeVerificationEnabled: boolean): string {
  if (isBadgeVerificationEnabled) {
    return "Start your shift";
  }

  return "Clock in now";
}
